import moment from 'moment';

import { CcmCampaignTimeline } from '../../types';

const PENDING = 'pending';
const ACTIVE = 'on_going';
const IN_ACTIVE = 'revoked';

export type CcmCampaignStatuses = typeof PENDING | typeof ACTIVE | typeof IN_ACTIVE;

export const getCCMCampaignStatus = (timeline: CcmCampaignTimeline): CcmCampaignStatuses => {
  const today = moment();

  if (moment(timeline.taskContentGoLiveDate).isAfter(today, 'day')) {
    return PENDING;
  }

  if (today.isAfter(moment(timeline.campaignEndDate), 'day')) {
    return IN_ACTIVE;
  }

  return ACTIVE;
};
